import { DateTimeRangePicker } from '@leverege/ui-elements';
import { useCallback, useEffect, useMemo, useState } from 'react';
import TimelineModel from "../TimelineModel.js";
export default function useDateTimeRange(opts) {
  const {
    settings
  } = opts || {};
  const [now, setNow] = useState(Date.now());
  const [range, setRange] = useState(() => TimelineModel.getRange(settings));
  const onChangeRange = useCallback(evt => {
    setRange(evt.value);
  }, []);
  const onChangeNow = useCallback(evt => {
    setNow(evt.value);
  }, []);
  const value = useMemo(() => {
    return DateTimeRangePicker.getRange(range);
  }, [range, now]);
  useEffect(() => {
    const sRange = TimelineModel.getRange(settings);
    if (sRange === range) {
      return;
    }
    if (sRange?.start === value?.start && sRange?.end === value?.end) {
      return;
    }
    setRange(sRange);
  }, [settings]);
  return {
    range: value,
    onChangeRange,
    now,
    onChangeNow
  };
}